import * as React from "react";
import HoldUtilHeader from "../../generic/holdUtilHeader";
import HoldMfUsableRowDsk from "./holdMfUsableRowDsk";
import HoldMfUsableRowMob from "./holdMfUsableRowMob";
import DeviceContext from "../../../../service/indentifyDevice";
import { HHoldDematGroupBy } from "../../../../service/holdings/holdGrpByHelper";
import Sort, { eSortState, sort } from "../../../../generic/sort";
import { SearchHighLight } from "../../../../service/generic/searchHighlight";
import NoDataContainer from "../../../../generic/noDataContainer";

if (DeviceContext().isDesktop) {
	require("../../../../../assets/scss/components/toc/holdings/holdTables/holdTableDsk.scss");
} else if (DeviceContext().isTablet) {
	require("../../../../../assets/scss/components/toc/holdings/holdTables/holdTableTab.scss");
} else {
	require("../../../../../assets/scss/components/toc/holdings/holdTables/holdTableMob.scss");
}

export interface IHoldMfUsableTableProps {
	data: Array<any>;
}

const heading = {
	scName: "Scheme Name",
	ct: "Category",
	mode: "Mode",
	hdgQty: "Qty",
	usdQty: "Used Qty",
	nav: "NAV",
	amount: "Holding Value"
};

const HoldMfUsableTable: React.FC<IHoldMfUsableTableProps> = props => {
	const isDematPhyCombPresent = checkDematPhyCombination();
	const [toggleState, setToggleState] = React.useState(false);
	const [filteredData, setFilteredData] = React.useState([props.data]);
	const [tableData, setTableData] = React.useState([props.data]);
	// to maintain the state of sorted column
	const [sortedColumnState, setSortedColumnState] = React.useState({ colName: null as string | null, sortState: eSortState.ASC });

	function parsePropData() {
		// deepcopy for searching, otherwise the changes happen through reference in SearchHighLight
		return props.data.map(row => ({ ...row }));
	}

	React.useEffect(() => {
		// parse data first
		const data = parsePropData();

		if (toggleState) {
			// when data comes initially, group it
			setFilteredData(HHoldDematGroupBy(data));
			setTableData(HHoldDematGroupBy(data));
		} else {
			setFilteredData([data]);
			setTableData([data]);
		}
	}, [props.data]);

	function checkDematPhyCombination() {
		// chack if there is any MTF holding in data
		let demat = false;
		let physical = false;

		// if both demat and physical become true inside the loop, then return true
		return !!props.data.find(data => {
			if (data.mode === "D") {
				demat = true;
			}
			if (data.mode === "P") {
				physical = true;
			}
			return demat && physical;
		});
	}

	function onSort(data: Array<Array<any>>, sortState: eSortState, colName: string) {
		setSortedColumnState({ colName, sortState });
		setTableData(data);
	}

	function sortAfterFilter(groupedData: Array<Array<any>>) {
		// if some column was sorted earlier, then sort that again
		if (sortedColumnState.colName) {
			// copy grouped data, because it will change after sorting
			// filtered data will also change with groupedData
			const copyGroupedData = groupedData.map(group => group.map(data => data));

			sort(copyGroupedData, sortedColumnState.sortState, sortedColumnState.colName, onSort);
		}
	}

	function handleToggleClick(groupedData: Array<Array<any>>, toggleState: boolean) {
		// set filtered data
		setToggleState(toggleState);
		setFilteredData(groupedData);
		setTableData(groupedData);

		sortAfterFilter(groupedData);
	}

	function handleSearch(filteredData: Array<Array<any>>, sText?: string | undefined) {
		if (sText) {
			const SearchText: string = sText.toLowerCase();
			const searchKey: string = "scName";

			// highlight the rows
			filteredData[0].forEach((row: any) => (row[searchKey] = SearchHighLight(row[searchKey], SearchText)));
		}

		// group data to pass into handle toggle click
		let groupedData: Array<Array<any>> = [];
		if (toggleState) {
			groupedData = HHoldDematGroupBy(filteredData[0]);
		} else {
			groupedData = filteredData;
		}

		handleToggleClick(groupedData, toggleState);
	}

	return (
		<>
			<HoldUtilHeader
				data={[parsePropData() || []]}
				searchKey="scName"
				onDataFilter={handleSearch}
				onToggleClick={handleToggleClick}
				onSearchClick={() => {}}
				defaultToggleState={isDematPhyCombPresent ? toggleState : undefined}
			/>

			<div className="hold_mf_usable_table_dsk hold_table">
				{!DeviceContext().isMobile && (
					<ul className="hdr_row">
						<li>
							<div className="col scName col_srt_cont">
								<Sort
									sortList={filteredData}
									sortedColName={sortedColumnState.colName}
									sortKey="scName"
									onSort={onSort}
									colName={heading.scName}
								/>
							</div>
							<div className="col ct">{heading.ct}</div>
							<div className="col mode">{heading.mode}</div>
							<div className="col qty w_80">
								{heading.hdgQty}
								<br />
								{heading.usdQty}
							</div>
							<div className="col nav w_80">{heading.nav}</div>
							<div className="col amount w_90">
								<Sort
									sortList={filteredData}
									sortedColName={sortedColumnState.colName}
									sortKey="amount"
									onSort={onSort}
									colName={heading.amount}
								/>
							</div>
						</li>
					</ul>
				)}

				{/* Flatten the array and check if there is anything to be shown */}
				{tableData.join().split(",")[0] ? (
					<div className="hold_scroll_cont">
						{tableData.map((group, groupIndex) => (
							<ul key={groupIndex}>
								{group.map((row, index) => (
									<React.Fragment key={index}>
										{!DeviceContext().isMobile ? <HoldMfUsableRowDsk rowData={row} /> : <HoldMfUsableRowMob rowData={row} />}
									</React.Fragment>
								))}
							</ul>
						))}
					</div>
				) : (
					<NoDataContainer txtHeading="No results found" />
				)}
			</div>
		</>
	);
};

export default HoldMfUsableTable;
